export enum ResultModel {
  Error,
  Success,
  MustChangePassword = 3,
}
